/*
  One place that owns document.title (client bug, 2026-09-17): a few pages set
  their own title and the rest set none, so whatever page you visited last kept
  its name in the browser tab. Now every route change writes the title here.
*/
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MICROSITES } from "../lib/microsites";

const BRAND = "Grid Masters";
const UL = "Ultimate Lap";

export function titleFor(pathname) {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/") return BRAND;
  if (p === "/about") return `About - ${BRAND}`;
  if (p === "/contact") return `Contact - ${BRAND}`;
  if (p === "/leaderboard") return `Leaderboard - ${UL} - ${BRAND}`;
  if (p.startsWith("/admin/print")) return `Sign-on sheet - ${BRAND} Admin`;
  if (p.startsWith("/admin")) return `${BRAND} Admin`;
  if (p === "/events/ultimate-lap") return `${UL} - ${BRAND}`;
  if (p === "/events/ultimate-lap/results") return `Championship standings - ${UL} - ${BRAND}`;
  if (p.startsWith("/events/ultimate-lap/enter")) {
    const rest = p.slice("/events/ultimate-lap/enter".length);
    const season = rest.startsWith("/season");
    if (rest.endsWith("/confirmed")) return `You're on the grid - ${UL} - ${BRAND}`;
    if (season) return `Season pass - ${UL} - ${BRAND}`;
    const m = /^\/(\d+)/.exec(rest);
    return m ? `Enter round ${m[1]} - ${UL} - ${BRAND}` : `Enter - ${UL} - ${BRAND}`;
  }
  const ms = /^\/events\/([^/]+)/.exec(p);
  if (ms) {
    const site = Object.values(MICROSITES).find((s) => s.slug === ms[1]);
    return site ? `${site.name} - ${BRAND}` : BRAND;
  }
  return `Off track - ${BRAND}`;
}

export default function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = titleFor(pathname);
  }, [pathname]);
  return null;
}
